import React from 'react';

import { useRouteParams } from 'src/hooks/useRouteParams';

import { OnboardingLayout } from '../../components';
import * as routes from '../../routes/routes';
import { EnterpriseTrialSignup } from '../enterpriseTrialSignup/EnterpriseTrialSignup';

import { Signup } from './Signup';

export const CombinedSignup = () => {
  const { type } = useRouteParams(routes.signup);

  // The Enterprise Trial is being sunset for the GraphOS Trial. We will want to
  // audit all paths that could be expecting this Signup flow (i.e. Sales funnels
  // that direct potential customers to the direct URL) and subsequently remove
  // all references to the Enterprise Trial in the onboarding flow.
  // See https://apollographql.atlassian.net/browse/ONB-223 for the conversion from
  // Enterprise trial to GraphOS Trial, and PR for the switch to GraphOS as a
  // default trial.
  if (type === 'enterprise-trial') {
    return <EnterpriseTrialSignup />;
  }

  return (
    <OnboardingLayout>
      <Signup />
    </OnboardingLayout>
  );
};
